import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default function StepChannelName({
  channelName,
  setChannelName,
  nameError,
}) {
  return (
    <TextField
      label="Nome do canal"
      placeholder="Canal financeiro"
      variant="outlined"
      value={channelName}
      onChange={(e) => setChannelName(e.target.value)}
      fullWidth
      sx={{ mt: 2 }}
      error={Boolean(nameError)}
      helperText={nameError}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <WhatsAppIcon sx={{ color: "#25D366" }} />
          </InputAdornment>
        ),
      }}
    />
  );
}
